<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6 offset-md-3">

        <!-- <h1>Ödeme Sonucu</h1> -->
        <p class="loading" v-if="loading"> {{$t('general.loading')}} ...</p>
        <h3 v-else :class="statusClass">
          {{ message }}<br><br>
          <a class="btn btn-outline-success" href="#" @click.prevent="goToPaymentHistory">
            <i class="uil-shopping-basket"/> {{ $t('general.go_my_orders') }} </a>
        </h3>

        <div v-if="showPossibleErrors" class="card mt-4">
          <div class="card-header">
            <h5 class="mb-0">
              <i class="uil-exclamation-triangle text-warning"></i>
               {{$t('general.possible_errors')}}
            </h5>
          </div>
          <div class="card-body">
            <p class="text-muted mb-3"> {{$t('payment.error.contact_bank')}}  </p>

            <div class="error-list">
              <div v-for="error in errorItems" :key="error.titleKey" class="error-item">
                <strong>{{ $t(error.titleKey) }}</strong>
                <p class="error-description">{{ $t(error.descriptionKey) }}</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { PAYMENT_ERROR_ITEMS } from "@/core/constant/payment-error-constants";

export default {
  name: "PaymentCallback",
  components: {},
  computed: {
    statusClass() {
      return {
        "success-text": this.status === "success",
        "error-text": this.status === "fail",
        "warning-text": !this.status,
      };
    },
    errorItems() {
      return PAYMENT_ERROR_ITEMS;
    }
  },
  data() {
    return {
      status: '',
      token: '',
      successMessage: null,
      errorMessage: null,
      message: "",
      loading: true,
      showPossibleErrors: false,
    };
  },
  methods: {
    getQueryParam(param) {
      const hash = window.location.hash;
      const queryString = hash.split('?')[1];
      if (!queryString) return null;

      const params = new URLSearchParams(queryString);
      return params.get(param);
    },
    async getParams() {
      this.loading = true;
      this.status = this.getQueryParam('status');
      this.token = this.getQueryParam('token');

      axios.get(`${'api/payment/' + this.token + '/status'}`, {
        headers: this.apiHeaders
      }).then((result) => {
        const responseData = result?.data?.data;
        this.status = responseData?.status;

        if (responseData?.status === 'success') {
          this.message = `✅ Siparişiniz başarıyla alınmıştır!`;
        } else if (responseData?.status === 'fail') {
          const errorMessage = responseData?.error_message || this.$t('general.payment_not_received');
          this.message = `❌ ${errorMessage}`;

          if (errorMessage === "Geçersiz işlem") {
            this.showPossibleErrors = true;
          }
        } else {
          this.message = this.$t('general.unexpected_error');
        }
      }).catch((error) => {
        console.error('Payment status check failed:', error);
        this.status = 'fail';
        this.message = `❌ ${this.$t('general.status_check_failed')}`;
      }).finally(() => {
        this.loading = false;
      })
    },
    goToPaymentHistory() {
      this.$router.push({ name: 'User.payment-history' });
    },
  },
  mounted() {
    this.getParams();
  },

}
</script>

<style scoped>
.container-fluid {
  text-align: center;
  min-height: 80vh;
  padding: 2rem 1rem;
  display: flex;
  align-items: center;
}

.container-fluid .row {
  width: 100%;
  margin: 0;
}


.success-text {
  color: green;
  font-weight: bold;
}

.error-text {
  color: red;
  font-weight: bold;
}

.warning-text {
  color: orange;
  font-weight: bold;
}

.card {
  border: none;
  border-radius: 1rem;
  background-color: #fff;
  backdrop-filter: blur(10px);
  margin-top: 2rem;
}

.card-header {
  padding: 0.5rem;
  margin-bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-bottom: none;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.card-header h5 {
  color: white;
  font-weight: 600;
}

.card-body {
  flex: 1 1 auto;
  padding: 1.5rem;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

.error-list {
  max-height: 400px;
  overflow-y: auto;
}

.error-item {
  padding: 0.75rem 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid #f5c6cb;
  border-radius: 0.375rem;
  background-color: #f8d7da;
  color: #721c24;
  position: relative;
  display: flex;
  flex-direction: column;
}

.error-item:last-child {
  margin-bottom: 0;
}

.error-item strong {
  color: #721c24;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
}

.error-item strong::before {
  content: "⚠";
  margin-right: 0.5rem;
  font-size: 1rem;
  color: #dc3545;
}

.error-description {
  color: #721c24;
  font-size: 0.85rem;
  margin: 0;
  line-height: 1.4;
  opacity: 0.8;
}

.text-warning {
  color: #ffc107 !important;
}

.text-muted {
  color: #6c757d !important;
}

h3 {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 0;
}

.btn-outline-success {
  border-width: 2px;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  color: #000 !important;
}

.btn-outline-success i {
  color: #000 !important;
}

/* Loading mesajı tasarımı */
p.loading {
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin: 0;
  font-size: 1.2rem;
  font-weight: 500;
  color: #667eea;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}



</style>
